import React, { useEffect, useMemo, useCallback, useState } from "react";
import { Box, Typography, FormControl, InputLabel, MenuItem, Select, Grid } from "@mui/material";

const PROCESSING_OPTIONS = [
  { value: "AddIfBlank", label: "Add If Blank" },
  { value: "Ignore", label: "Ignore" }, 
  { value: "Overwrite", label: "Overwrite" }
];

const ProcessingRulesForm = ({ data, setProcessingState }) => {
  // Memoize initial state computation
  const initialState = () => 
    Object.fromEntries(
      Object.keys(data).map((field) => [field, data[field]])
    )

  const [dummyProcessingState, setDummyProcessingState] = useState(initialState)

  // Memoized handler for select changes
  const handleChange = useCallback((field, value) => {
    setDummyProcessingState(prevState => ({
      ...prevState,
      [field]: value,
    }));
  }, [setDummyProcessingState]);

  // Sync state with parent when data changes
  useEffect(() => {
    setProcessingState(dummyProcessingState);
  }, [initialState, dummyProcessingState]);

  useEffect(() => {
    setDummyProcessingState(initialState)
  }, [data])

  // Memoize field rendering function
  const renderField = useCallback((field) => {
    const label = field.replace(/_/g, " ").toUpperCase();
    
    return (
      <Grid item xs={2} key={field}>
        <FormControl fullWidth>
          <InputLabel>{label}</InputLabel>
          <Select
            label={label}
            value={dummyProcessingState[field]} // Use data directly instead of initialState
            onChange={(e) => handleChange(field, e.target.value)}
            sx={{ height: '45px', '& .MuiSelect-select': { height: '45px !important' } }}
          >
            {PROCESSING_OPTIONS.map(({value, label}) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    );
  }, [handleChange, dummyProcessingState]); // Update dependency to data

  return (
    <Box sx={{ pt: 2, pb: 1, gap: 2 }}>
      <Typography variant="h6">Processing Rules</Typography>
      <Grid container spacing={3} sx={{ pt: 2 }}>
        {Object.keys(dummyProcessingState).map(renderField)} {/* Use data directly */}
      </Grid>
    </Box>
  );
};

export default ProcessingRulesForm;
